import { useRecoilValueLoadable } from 'recoil';
import { DropDownButton } from 'components';
import { useAccountParam } from 'hooks';
import { filteredDisputeReasons } from 'state';
import { DisputeReason } from 'types';
import { useResolvedDropdownItems } from './useResolvedDropdownItems';

export interface DisputeReasonFilterProps{
    disputeReasonId?: number,
    onDisputeReasonIdChange: (value?: number) => void,
}

const AllOption = {
    description: 'All'
};

const DisputeReasonFilter = ({disputeReasonId, onDisputeReasonIdChange} : DisputeReasonFilterProps) => {
    const accountId = useAccountParam();
    const optionsLoadable = useRecoilValueLoadable(filteredDisputeReasons(accountId));
    const options = useResolvedDropdownItems<DisputeReason>(accountId, optionsLoadable);
    
    return (
        <DropDownButton
            items={[AllOption, ...options]}
            text={`Dispute reason: ${options.find((reason) => reason.disputeReasonId === disputeReasonId)?.description ?? 'All'}`}
            onItemClick={(e) => onDisputeReasonIdChange(e.item.disputeReasonId)}
            textField="description"
        />
    );
}

export default DisputeReasonFilter;
